<template>
  <div id="employee-detail">
    <CRow>
      <CCol class="employees-form" md="6" sm="12">
        <div class="text-label">
          <h3>
            {{ $t("project.label_project_information") }}
          </h3>
        </div>
        <div class="text-label-content">
          <div class="text-content">
            <label>{{ $t("project.label_project_name") }}</label>
            <div class="show-text">{{ project.name }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("customer.label_customer_company_name") }}</label>
            <div class="show-text">{{ project.company_name }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.label_project_start_date") }}</label>
            <div class="show-text">{{ project.start_date }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.label_project_end_date") }}</label>
            <div class="show-text">{{ project.end_date }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.label_project_type") }}</label>
            <div class="show-text">{{ getProjectType(parseInt(project.project_type)) }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.description") }}</label>
            <div class="show-text">{{ project.description }}</div>
          </div>
        </div>
      </CCol>
      <CCol class="employees-form" md="6" sm="12">
        <div class="text-label-content-form">
          <div class="text-content mt-tablet-45">
            <label>{{ $t("employee.label_develop_division") }}</label>
            <div class="show-text">
              {{ departmentName }}
            </div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.label_project_status") }}</label>
            <div class="show-text">
              {{ project.status ? $t("employee.label_project_status_" + project.status) : "" }}
            </div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.contract_value") }}</label>
            <div class="show-text">{{ project.contract_value }}</div>
          </div>
          <div class="text-content">
            <label>{{ $t("project.label_project_total_member") }}</label>
            <div class="show-text">{{ project.total_member }}</div>
          </div>
        </div>
      </CCol>

    </CRow>
    <CRow>
      <CCol class="employees-form mb-mobile-1" md="12" sm="12">
        <div class="text-label">
          <h5>
            {{ $t("project.label_project_information_member") }}
          </h5>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-project">
            <table class="table table-mobile">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  {{ $t("label.full_name") }}
                </th>
                <th scope="col">
                  {{ $t("label.position") }}
                </th>
                <!--                  <th scope="col">-->
                <!--                    {{ $t("project.employee_skill") }}-->
                <!--                  </th>-->
                <th scope="col">
                  {{ $t("project.label_project_member_start_date") }}
                </th>
                <th scope="col">
                  {{ $t("project.label_project_member_end_date") }}
                </th>
                <th scope="col">
                  {{ $t("project.effort") }}
                </th>
              </tr>
              </thead>
              <tbody v-for="(item, index) in project.memberEmployeeProject" :key="index">
              <tr>
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ item.name_member }}</td>
                <td>{{ item.employee_type }}</td>
                <!--                  <td>{{ item.skill_member }}</td>-->
                <td>{{ item.member_project_start_date }}</td>
                <td>{{ item.member_project_end_date }}</td>
                <td>{{ item.employee_effort }}</td>
              </tr>
              <tr v-for="(itemRangeTime, indexRangeTime) in item.employee_range_time"
                  :key="`rangeTime${indexRangeTime}`"
                  class="addition-range-time">
                <th scope="row"></th>
                <td></td>
                <td></td>
                <td>{{ itemRangeTime.member_project_start_date }}</td>
                <td>{{ itemRangeTime.member_project_end_date }}</td>
                <td>{{ itemRangeTime.effort }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol class="text-center mb-3 mb-md-0" md="12" sm="12">
        <router-link
          :to="{ name: 'projects.edit', params: { id: this.project.id } }"
          class="btn btn-success"
          tag="a"
        >
          <CIcon
            name="cil-pencil"
            style="margin-right: 3px; border: 1px solid #fff;"
          ></CIcon>
          {{ $t("button.label_action_edit") }}
        </router-link>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: "Project",
  metaInfo() {
    return {
      title: this.$t("page_title.page_project_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {};
  },

  created() {
    this.projectDetail();
  },

  computed: {
    ...mapGetters({
      project: "project/project"
    }),
    departmentName() {
      return this.project.department?.name ?? '';
    }
  },

  methods: {
    ...mapActions("project", ["showDetail"]),

    async projectDetail() {
      let id = await this.$route.params.id;
      if (id) {
        await this.showDetail(id);
      }
    },

    getProjectType(type) {
      switch (type) {
        case 1:
          return 'SPOT';
        case 2:
          return 'LABO';
        case 3:
          return 'MAINTAIN';
        case 4:
          return 'OTHER';
        default:
          return '';
      }
    },
  }
};
</script>
<style lang="scss" scoped>
#employee-detail {
  padding: 20px 100px;

  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label-content {
      margin-top: 33px;

      .label-text {
        color: #000;
      }

      .table-project {
        background-color: white;
      }
    }

    .text-label-content-form {
      margin-top: 63px;
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 3px 10px;
      height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .span-label {
        float: right;
      }
    }

    .addition-range-time {
      background-color: aliceblue;
    }
  }
}

@media only screen and (max-device-width: 767px) {
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0 0.3rem;
    margin-bottom: 0;

    .text-label-content {
      margin-top: 1rem;
    }

    .text-content {
      display: block;
    }

    .show-text {
      width: 100%;
      border-radius: 3px;
    }

    .text-label-content-form {
      margin-top: 0;
    }
  }
  .mb-mobile-1 {
    margin-bottom: 0.25rem;
  }
  .table-mobile {
    width: 520px;
    overflow: scroll;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0 0.3rem;
    margin-bottom: 0;

    .text-label-content {
      margin-top: 1rem;
    }

    .text-content {
      display: block;
    }

    .show-text {
      width: 100%;
      border-radius: 3px;
    }

    .text-label-content-form {
      margin-top: 0;
    }

    .mt-tablet-45 {
      margin-top: 45px;
    }
  }
}
</style>
